export const Divider = (props: React.HTMLAttributes<HTMLHRElement>) => (
  <hr className="w-full h-px border-border-bg-neutral" {...props} />
);
